import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';

import UserContext from '../context/UserContext';

/**
 * Render the component when the pathname is in the whitelist or redirect to first step.
 * @param Component
 * @param access
 * @param rest
 * @return {*}
 * @constructor
 */
const ProtectedRoute = ({ children, ...rest }) => {
  const { steps } = useContext(UserContext);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        steps.find(page => page === location.pathname) ?
          children :
          <Redirect
            to={{
              pathname: "/ident",
              state: { from: location }
            }}
          />
      }
    />
  )
}

export default ProtectedRoute;
